const seoLinking: any = {
  // L2
  '/kategorie/elektryk': [
    { title: 'instalacje elektryczne Poznań', url: '/kategoria/instalacje-elektryczne/poznan' },
    { title: 'usługi elektryczne Katowice', url: '/kategoria/instalacje-elektryczne/katowice' },
    { title: 'elektryk Siedlce', url: '/kategorie/elektryk/siedlce' },
  ],

  // L2-city
  '/kategorie/projektowanie/wroclaw': [
    { title: 'złota rączka Wrocław', url: '/kategorie/zlota-raczka/wroclaw' },
    { title: 'naprawa sprzętu agd Wrocław', url: '/kategoria/naprawa-sprzetu-agd/wroclaw' },
    { title: 'remont łazienki Wrocław', url: '/kategoria/remont-lazienki/wroclaw' },
  ],

  // L4
  '/kategoria/renowacja-mebli': [
    { title: 'oklejanie mebli', url: '/kategoria/oklejanie-mebli' },
    { title: 'tapicerowanie mebli', url: '/kategoria/tapicerowanie-mebli' },
    { title: 'transport mebli', url: '/kategoria/transport-mebli' },
  ],

  // L4-city
};

export default seoLinking;
